import { authRequest } from "./index.js";
import { formatResponse } from "@/utils/errorHandler";

// Because authRequest baseURL is .../admin, we don't need to prepend /admin here
export async function get_backup_logs(query = {}) {
  try {
    const result = await authRequest.get('/backup_logs', { params: query })
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}

export async function create_backup() {
  try {
    const result = await authRequest.post('/backup_logs')
    return formatResponse(result.data, false)
  } catch (error) {
    return formatResponse(null, true, error)
  }
}
